import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../helper/api";

export const myCasinoBets = createAsyncThunk(
  "myCasinoBets",
  async (payload, thunkAPI) => {
    try {
      
      const response = await api.post("casino_bets/get-by-user", payload);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue("Something went wrong");
    }
  }
);

const myCasinoBetsSlice = createSlice({
  name: "myCasinoBets",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(myCasinoBets.pending, (state) => {
        state.loading = true;
      })
      .addCase(myCasinoBets.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(myCasinoBets.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default myCasinoBetsSlice.reducer;
